export default __webpack_public_path__ + "static/media/calendar (1).65ea0242.svg";